/**
 * Created by litao on 2018/10/8.
 */
import de from "element-ui/src/locale/lang/de";

export default (http) => {
    return {
        /**
         * 分页查询
         * @param data
         * @return {*}
         */
        query (data){
            return http.json({
                url: `/pro/goods/log/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            })
        },

        queryElectricPage (data){
            return http.json({
                url: `/erp/warranty/card/queryElectricRecord?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            })
        },


    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/progoodsLog.js